import React from 'react';
import { Mail, ExternalLink, BookOpen, Users, TrendingUp, Shield } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="border-t bg-gray-900 text-white mt-auto footer-bg print:hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center mb-4">
              <img 
                src="/logo.svg" 
                alt="IEP Management Tool Logo" 
                className="h-8 w-auto mr-3 logo-adaptive-footer"
              />
              <h3 className="text-2xl font-bold text-primary">
                IEP Management Tool
              </h3>
            </div>
            <p className="mb-4 text-gray-300">
              Empowering educators to track student IEP goals, monitor progress, and ensure compliance with accessibility-first design.
            </p>
            <button className="inline-flex items-center px-4 py-2 border border-gray-600 rounded-md text-sm font-medium text-white hover:bg-gray-800 transition-colors">
              <Mail className="mr-2 h-4 w-4" />
              Support
            </button>
          </div>

          <div>
            <h4 className="mb-4 text-lg font-semibold">Features</h4>
            <ul className="space-y-2">
              <li>
                <span className="flex items-center text-gray-300">
                  <Users className="mr-2 h-4 w-4" />
                  Student Management
                </span>
              </li>
              <li>
                <span className="flex items-center text-gray-300">
                  <BookOpen className="mr-2 h-4 w-4" />
                  Goal Tracking
                </span>
              </li>
              <li>
                <span className="flex items-center text-gray-300">
                  <TrendingUp className="mr-2 h-4 w-4" />
                  Progress Monitoring
                </span>
              </li>
              <li>
                <span className="flex items-center text-gray-300">
                  <Shield className="mr-2 h-4 w-4" />
                  WCAG 2.1 AA Compliant
                </span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-lg font-semibold">Resources</h4>
            <ul className="space-y-2">
              <li>
                <a href="#getting-started" className="text-gray-300 hover:text-white transition-colors">
                  Getting Started
                </a>
              </li>
              <li>
                <a href="#accessibility" className="text-gray-300 hover:text-white transition-colors">
                  Accessibility Guide
                </a>
              </li>
              <li>
                <a href="#data-privacy" className="text-gray-300 hover:text-white transition-colors">
                  Data Privacy
                </a>
              </li>
              <li>
                <a href="https://www.ed.gov/about/offices/list/osers/osep/idea-guidance.html" 
                   className="flex items-center text-gray-300 hover:text-white transition-colors"
                   target="_blank"
                   rel="noopener noreferrer">
                  IDEA Guidelines <ExternalLink className="ml-1 h-3 w-3" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
            <div className="mb-4 md:mb-0">
              <p>&copy; {new Date().getFullYear()} IEP Management Tool. All rights reserved.</p>
            </div>
            <div className="flex space-x-6">
              <span className="text-gray-400">
                Local Storage Only - Your data stays private
              </span>
            </div>
          </div>
          
          <div className="mt-4 text-xs text-gray-500 text-center">
            <p>
              This application stores all data locally in your browser. 
              No personal information is transmitted or stored on external servers.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;